import actionTypes from "../../redux/actionTypes";
import { ActionCreator, Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../../redux/initialState";
import { SelectedServiceType } from "./selectedServiceTypeTypes";

export type AppThunk = ActionCreator<ThunkAction<void, ApplicationState, SelectedServiceType, Action<string>>>;

export const updateServiceTypeFilter: ActionCreator<ThunkAction<void, ApplicationState, any, Action<string>>> = serviceTypeFilter => {
  return (dispatch: Dispatch): Action => {
    try {
      return dispatch({
        type: actionTypes.UPDATE_SERVICE_TYPE_FILTER_SUCCESS,
        payload: serviceTypeFilter,
      });
    } catch (e) {
      return dispatch({
        type: actionTypes.UPDATE_SERVICE_TYPE_FILTER_ERROR,
        payload: null,
      });
    }
  };
};
